"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('kyc-manual-directions');
var KYC_ManualDirectionsComponent = function KYC_ManualDirectionsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("kyc"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes('description')
  }, t(props.section.directions)), /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:".concat(props.section.email),
    className: classes('email')
  }, props.section.email));
};
KYC_ManualDirectionsComponent.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func,
  onConfirm: _propTypes["default"].func
};
var _default = exports["default"] = KYC_ManualDirectionsComponent;